<template>
  <div>
    <a-layout-content style="padding: 0 0px">
      <div :style="{ background: '#fff', padding: '0px', minHeight: '280px' }">
        <router-view/>
      </div>
    </a-layout-content>
  </div>
</template>

<script>


export default {
  name: "layout-content",
  components: {}
}
</script>

<style scoped>

</style>